import { IconArrow } from "@/components/common/icon-arrow"
import { Link } from "react-router"
import type { LinkProps } from "react-router"

// biome-ignore lint/complexity/noExcessiveCognitiveComplexity:
export default function ButtonGoTo({
  text,
  to,
  className,
  variant = "default",
  variantHover = "default",
  ...rest
}: {
  text: string
  to: string
  className?: string
  variant?: "default" | "main" | "sub" | "outline-main" | "outline-sub"
  variantHover?: "default" | "main" | "sub" | "outline-main" | "outline-sub"
} & Omit<LinkProps, "to" | "className">) {
  return (
    <>
      <Link
        to={to}
        // biome-ignore format:
        className={`
          relative
          w-full md:w-[200px] h-[42px]
          flex items-center justify-center
          font-bold
          border border-solid
          ${
            variant === "main"
              ? "border-theme-main bg-theme-main text-other-main [&_path]:stroke-other-main"
            : variant === "sub"
              ? "border-theme-sub bg-theme-sub text-other-main [&_path]:stroke-other-main"
            : variant === "outline-main"
              ? "border-theme-main bg-other-main text-theme-main [&_path]:stroke-theme-main"
            : variant === "outline-sub" || variant === "default"
              ? "border-theme-sub bg-other-main text-theme-sub [&_path]:stroke-theme-sub"
            : ""
          }
          ${
            variantHover === "main" || variantHover === "default"
              ? "md:hover:border-theme-main md:hover:bg-theme-main md:hover:text-other-main md:[&_path]:hover:stroke-other-main"
            : variantHover === "sub"
              ? "md:hover:border-theme-sub md:hover:bg-theme-sub md:hover:text-other-main md:[&_path]:hover:stroke-other-main"
            : variantHover === "outline-main"
              ? "md:hover:border-theme-main md:hover:bg-other-main md:hover:text-theme-main md:[&_path]:hover:stroke-theme-main"
            : variantHover === "outline-sub"
              ? "md:hover:border-theme-sub md:hover:bg-other-main md:hover:text-theme-sub md:[&_path]:hover:stroke-theme-sub"
            : ""
          }
          ${className}
        `}
        {...rest}
      >
        <span className="inline-block font-bold text-[14px]">{text}</span>
        <span className="absolute top-1/2 -translate-y-1/2 right-6">
          <IconArrow className="size-3 self-center" />
        </span>
      </Link>
    </>
  )
}
